var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToolsMidpoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 985 1440",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ToolsMidpoint-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0-mid { fill: none;stroke: #ff0000;stroke-width: 2 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-mid",
    d: "m325 971.8l652.8-246.3-460.2 339.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-mid",
    d: "m825.9 967.8l151.9-242.3-230.5 740.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-mid",
    d: "m212.5 579.7l765.3 145.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-mid",
    d: "m862.5 39l109.1 685.3-794.5-342.7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-mid",
    d: "m254.1 39l717.5 691-526.4-348.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-mid",
    d: "m710.3 189.5l261.3 540.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-mid",
    d: "m177.1 823.7l-191.5-98.2h417.3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-mid",
    d: "m21.8 920.4l-36.2-194.9 303 587.2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-mid",
    d: "m177.1 1465.6l-191.5-740.1 761.7 587.2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-mid",
    d: "m971.6 285.6l-986 439.9 609.5-585.4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-mid",
    d: "m212.5 285.6l-226.9 439.9 74.3-740.1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-mid",
    d: "m747.3 189.5l-268.7-196.4 462.8 96.1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-mid",
    d: "m595.1 332.6l-116.5-339.5 304.5 483.6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-mid",
    d: "m595.1 1114l-116.5-1120.9 383.9 1472.5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-mid",
    d: "m61.6 1206.9l422.4-1213.8-159 1071.7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-mid",
    d: "m-14.4 140.1l493-147-224.5 241.8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-mid",
    d: "m177.1 1214.6l301.5 241.6-417-143.5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-mid",
    d: "m785.1 1413.1l-301.1 43.1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-mid",
    d: "m977.8 1214.6l-499.2 241.6 156-290.9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-mid",
    d: "m710 536l-226 920.2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-mid",
    d: "m478.6 968.6v482.2l-112.2-635.7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-mid",
    d: "m-14.4 528.6l493 922.2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0-mid",
    d: "m99 140.1l379.6 1316.1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsMidpoint);
export default __webpack_public_path__ + "static/media/ToolsMidpoint.d6f87cde47ef5ad192228622121b2d48.svg";
export { ForwardRef as ReactComponent };